// src/components/owners.jsx
// OwnerBadge and OwnerSelect for displaying/assigning company/contact owners.
//
// IMPORTANT: HubSpot stores owners by their HubSpot Owner ID (e.g. "78901234").
// Our local CRM users have their own ID (e.g. "u_1234567890") plus an optional
// hubspotOwnerId field. When matching an ownerId from HubSpot data, we check
// BOTH so HubSpot-assigned owners display correctly.

// Look up a user by either local id or hubspotOwnerId.
// Exported so other components can use the same logic.
export function findOwner(ownerId, users) {
  if (!ownerId) return null;
  const idStr = String(ownerId);
  return users.find(u =>
    String(u.id) === idStr ||
    (u.hubspotOwnerId && String(u.hubspotOwnerId) === idStr)
  ) || null;
}

export function OwnerBadge({ownerId, users}) {
  const o = findOwner(ownerId, users);
  if (!o) {
    // If we have an ownerId but no matching user, show the raw HubSpot ID
    // so admins know an owner IS set, just not linked yet.
    if (ownerId) {
      return (
        <span style={{fontSize:11,color:"var(--muted)",fontStyle:"italic"}}>
          HS#{String(ownerId).slice(0, 8)}
        </span>
      );
    }
    return <span style={{fontSize:11,color:"var(--muted)",fontStyle:"italic"}}>Unassigned</span>;
  }
  const d = o.name || (o.email && o.email.includes("@") ? o.email.split("@")[0] : (o.email || "User"));
  return (
    <span style={{display:"inline-flex",alignItems:"center",gap:5,fontSize:11,color:"var(--brown)",fontWeight:600}}>
      <span style={{width:18,height:18,borderRadius:99,background:"var(--warm2)",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:700,color:"var(--brown)",flexShrink:0}}>
        {d[0].toUpperCase()}
      </span>
      {d}
    </span>
  );
}

export function OwnerSelect({value, onChange, users}) {
  // The select's value should match how the option's value is rendered.
  // We use HubSpot owner ID when available (so saving sends the right thing
  // to HubSpot), falling back to local id otherwise.
  const matched = findOwner(value, users);
  const currentVal = matched ? (matched.hubspotOwnerId || matched.id) : (value || "");

  return (
    <select value={currentVal} onChange={e => onChange(e.target.value || null)}
      style={{padding:"8px 12px",borderRadius:10,border:"1.5px solid var(--warm2)",background:"var(--warm1)",fontSize:12,color:"var(--text)",outline:"none"}}>
      <option value="">- Unassigned -</option>
      {users.filter(u => !u.isAdmin).map(u => (
        <option key={u.id} value={u.hubspotOwnerId || u.id}>
          {u.name || u.email}{u.hubspotOwnerId ? "" : " (no HS link)"}
        </option>
      ))}
    </select>
  );
}
